import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-modal-cns-basico',
  templateUrl: './modal-cns-basico.component.html',
  styleUrls: ['./modal-cns-basico.component.css']
})
export class ModalCnsBasicoComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalCnsBasicoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onCloseClick() {
    this.dialogRef.close();
  }

}

